import React from "react";
import arrow_icon from "../../../assets/icons/right-arrow.png";
import TermsAndConditionsPopup from '../../profile/TermsAndConditionsPopup'
import '../widget.css'

const WidgetPayment = ({ toggleTerms }) => {


  return (
    <div>
      <div className="widget-main__container ">
        <div className="widget-Back-from-Terms-wrapper" >
          <img
            className="widget-Terms-left-arrow-image"
            src={arrow_icon}
            alt=""
            onClick={toggleTerms}
          />
          <div className="widget-back-button" onClick={toggleTerms} > Back </div>
        </div>
        <TermsAndConditionsPopup />
      </div>
    </div>
  )
}
export default WidgetPayment;
